import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import AddEdge from '../../AddEdge';

function CreateEntityModal({ open, onClose, onSubmit }) {
  const [name, setName] = useState('');
  const [edgeBeingAdded, setEdgeBeingAdded] = useState({});

  const onEdgeFieldChange = field => e => {
    setEdgeBeingAdded(current => ({
      ...current,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    if (!name.trim()) return;

    const nodeInProgress = { name };
    if (edgeBeingAdded.type && edgeBeingAdded.nodeB) {
      nodeInProgress.edges = [{
        // nodeA: '', // entity being created is node A
        nodeB: edgeBeingAdded.nodeB,
        type: edgeBeingAdded.type,
        // userId: prev.userId,
        properties: [],
        propertiesById: {},
      }];
    }

    onSubmit(nodeInProgress);

    setName('');
    setEdgeBeingAdded({});
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <form onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}>
        <DialogTitle>Create New Entity</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Entity Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <AddEdge
            onTypeChange={ onEdgeFieldChange('type') }
            onNodeChange={ onEdgeFieldChange('nodeB') }
            nodeType="Node B"
            type={ edgeBeingAdded.type }
            nodeId={ edgeBeingAdded.nodeB }
            showAddButton={ false }
            // onAddClicked={ onAddClicked }
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained">Create</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CreateEntityModal;
